import * as React from 'react';
import Fade from 'react-reveal';
import Divider from 'src/core/ui/divider';
export interface TeamMemberProps {
    name:string;
    occupancy: string;
    email: string;
    image?: any;
    className?: string;
}


export interface TeamMemberState {
}

export default class TeamMember extends React.Component<TeamMemberProps, TeamMemberState> {
  constructor(props: TeamMemberProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      /* <Fade bottom> */
        <div className={"team-member " + (this.props.className || '')}>
              
              <img className="member-image" src={this.props.image}/>

              <div className="member-card">
                <h5>{this.props.occupancy}</h5>
                <h4>{this.props.name}</h4>
                <Divider size="medium"/>
              </div>
        </div>
      /* </Fade> */
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/parts/team/team-member.tsx